import React from 'react';

import { Table, TableContainer } from '@mui/material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import { IStaffTravel } from '../../../../types/staff-travel.type';
import StaffTravelListBody from '../StaffTravelListBody';
import StaffTravelListFooter from '../StaffTravelListFooter';
import StaffTravelListHead from '../StaffTravelListHead';

interface IProps {
  travel: IStaffTravel[];
}

const StaffTravelList = React.memo(({ travel }: IProps) => (
  <Grid container mt={3}>
    <Grid item xs={12}>
      <TableContainer component={Paper} sx={{ maxHeight: '80vh' }}>
        <Table stickyHeader aria-label="sticky table">
          <StaffTravelListHead />
          <StaffTravelListBody travel={travel} />
          <StaffTravelListFooter travel={travel} />
        </Table>
      </TableContainer>
    </Grid>
  </Grid>
));

export default StaffTravelList;
